export const httpMethods = {
  get: "GET",
  post: "POST",
  delete: "DELETE",
  put: "PUT",
};
